import * as caseTypes from './casesTypes';
import {
  fetchFilterCasePhases,
  fetchFilterEyStatus,
  fetchFilterPhaseEyStatus,
  getCaseFiltersAPI,
  getImmigrationPathway,
  saveCasePathway,
  fetchCases,
  fetchDashboardNewCases,
  fetchCaseDetail,
  fetchDetailsHeader,
  updateCasePhaseService,
  fetchCasePhasesService,
  fetchCaseConsents,
  openDocument,
  downloadAnswerKeyXML,
  deliverReturnStatus,
  syncSurePrepBinderStatus,
  fetchEYCaseStatus,
  initiateEFileStatus,
  downloadSurePrepBinderService,
  getPrimaryCaseContacts,
  getSecondaryCaseContacts,
  getTeritaryCaseContacts,
  getCOEMemberCaseContacts,
  getDelegateCaseContacts,
  setFavoriteMarkService,
  upadteDelegateProfileservice,
  fetchGetCaseStatus,
  fetchAdditionalInfo,
  fetchFilterServiceType,
  fetchFilterCountryByCaseYear,
  getTaxcaddyList,
  updateExtensionDetails,
  deleteCaseService,
  resetBinderCreateStatus,
  resetDocumentsUploadStatus,
  fecthMissingInformationDetails,
  addMissingInfoDialog,
  deliverReturnPriceInfoService
} from 'src/services/cases.service';
import { openDocumentAPI } from 'src/services/documents.service';
import { showNotification } from 'src/utils/utilsActions';
import { fetchChaseFrequencyList } from 'src/services/engagements.service';
import download from 'downloadjs';
import mime from 'mime-types';
import { saveAPIFile } from 'src/helpers';
import { getProductListByOrgYearService } from 'src/services/cms.service';
import { createTaxChatQuestionnaireService } from 'src/services/questionnaire.service';
import {
  getExperianResultsService,
  getExperianPDFService,
  getExperianTestExportToPDFService,
  getExperianBgCheckResultsService,
  personProfilePdfByResourceCodeSvc,
  updateBackgroundCheckDetailSvc,
} from 'src/services/experian.service';
import { onChange } from '../state/casesFilterAction';
//import { getCaseManagerId } from './casesReselect';
/** work converted from sagas **/

export const upadteDelegateProfile = (caseManagerId, oldDelegateProfileKey, delegateProfileKey, deActivate) => {
  return async dispatch => {
    const response = await upadteDelegateProfileservice(caseManagerId, oldDelegateProfileKey, delegateProfileKey, deActivate);
    return response;
  };
};

export const updateExtension = extensionDetails => {
  return async dispatch => {
    const response = await updateExtensionDetails(extensionDetails);
    return response;
  };
};

export const getCaseDetails = caseManagerId => {
  return async (dispatch, getState) => {
    /* two pieces to the details page: Details information + Details Header */
    const [detailsResult, detailsHeaderResult] = await Promise.all([fetchCaseDetail(caseManagerId), fetchDetailsHeader(caseManagerId)]);

    if (detailsResult.success && detailsHeaderResult.success) {
      dispatch(getCaseDetailsSuccess(detailsResult.messages, detailsHeaderResult.messages));
    }
  };
};

export const getlinkedCases = caseManagerId => {
  return async (dispatch, getState) => {
    /* two pieces to the details page: Details information + Details Header */
    const linkedCasesResult = await Promise([fetchCaseDetail(caseManagerId)]);

    if (linkedCasesResult.success) {
      dispatch(getlinkedCasesSuccess(linkedCasesResult.messages));
    }
  };
};

export const getlinkedCasesSuccess = caseDetails => ({
  type: caseTypes.CASES_GET_LINKED_CASE_SHOWFLAG,
  caseDetails,
});

export const getCaseDetailsSuccess = (caseDetails, caseDetailsHeader) => ({
  type: caseTypes.GET_CASE_DETAILS_SUCCESS,
  caseDetails,
  caseDetailsHeader,
});

/** work converted from sagas **/

export const getCaseIdsPending = statusType => ({
  type: caseTypes.GET_CASE_IDS_PENDING,
  statusType,
});

export const getCaseIdsSuccess = payload => ({
  type: caseTypes.GET_CASE_IDS_SUCCESS,
  payload,
});

export const getCaseIdsFailure = error => ({
  type: caseTypes.GET_CASE_IDS_FAILURE,
  error,
});

export const getCaseDetailPending = caseId => ({
  type: caseTypes.GET_CASE_DETAIL_PENDING,
  caseId,
});

export const getCaseDetailSuccess = data => ({
  type: caseTypes.GET_CASE_DETAIL_SUCCESS,
  data,
});

export const getCaseDetailFailure = error => ({
  type: caseTypes.GET_CASE_DETAIL_FAILURE,
  error,
});

export const getExtensionDetailsContactsSuccess = payload => ({
  type: caseTypes.GET_EXTENSION_DETAILS_CONTACTS,
  payload,
});

export const getPrimaryCaseContactslist = (caseManagerId, engagementId) => {
  return async dispatch => {
    try {
      let res = await getPrimaryCaseContacts(caseManagerId, engagementId);
      if (res && res.success) {
        dispatch(getPrimaryCaseContactsSuccess(res.messages));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getPrimaryCaseContactsSuccess = payload => ({
  type: caseTypes.GET_PRIMARYCASE_CONTACTS,
  payload,
});

export const getSecondaryCaseContactslist = (caseManagerId, engagementId) => {
  return async dispatch => {
    try {
      let res = await getSecondaryCaseContacts(caseManagerId, engagementId);
      if (res && res.success) {
        dispatch(getSecondaryCaseContactsSuccess(res.messages));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getSecondaryCaseContactsSuccess = payload => ({
  type: caseTypes.GET_SECONDARYCASE_CONTACTS,
  payload,
});

export const getTeritaryCaseContactslist = (caseManagerId, engagementId) => {
  return async dispatch => {
    try {
      let res = await getTeritaryCaseContacts(caseManagerId, engagementId);
      if (res && res.success) {
        dispatch(getTeritaryCaseContactsSuccess(res.messages));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getTeritaryCaseContactsSuccess = payload => ({
  type: caseTypes.GET_TERITARY_CONTACTS,
  payload,
});

export const getCOEMemberCaseContactslist = (caseManagerId, engagementId) => {
  return async dispatch => {
    try {
      let res = await getCOEMemberCaseContacts(caseManagerId, engagementId);
      if (res && res.success) {
        dispatch(getCOEMemberCaseContactsSuccess(res.messages));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getCOEMemberCaseContactsSuccess = payload => ({
  type: caseTypes.GET_COE_MEMBER_CONTACTS,
  payload,
});

export const getDelegateCaseContactslist = (caseManagerId, engagementId) => {
  return async dispatch => {
    try {
      let res = await getDelegateCaseContacts(caseManagerId, engagementId);
      if (res && res.success) {
        dispatch(getDelegateCaseContactsSuccess(res.messages));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getDelegateCaseContactsSuccess = payload => ({
  type: caseTypes.GET_DELEGATECASE_CONTACTS,
  payload,
});

export const getCasesSuccess = payload => {
  return dispatch => {
    // dispatch(hydrateCasesFilters(filters));
    dispatch({
      type: caseTypes.GET_CASES_SUCCESS,
      payload,
    });
  };
};
export const getNewDashboardCasesSuccess = payload => {
  return dispatch => {
    dispatch({
      type: caseTypes.GET_NEW_CASES_SUCCESS,
      payload,
    });
  };
};

export const getCasesPending = (params, config) => {
  return async dispatch => {
    try {
      let res = await fetchCases(params, config);
      if (res && res.success) {
        dispatch(getCasesSuccess(res));
        dispatch(hydrateCasesParams(params));
      } else if (res && !res.success) {
        dispatch(showNotification(res.error.message, { variant: 'error' }));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getDashboardNewCases = (params, config) => {
  return async dispatch => {
    try {
      let res = await fetchDashboardNewCases(params, config);
      if (res && res.success) {
        dispatch(getNewDashboardCasesSuccess(res));
        dispatch(hydrateCasesParams({ caseStatusType: 'Open', status: 1, ...params }));
      } else if (res && !res.success) {
        dispatch(showNotification(res.error.message, { variant: 'error' }));
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const hydrateCasesParams = payload => ({
  type: caseTypes.SET_CASES_PARAMS_SUCCESS,
  payload,
});

export const hydratePopulatePayload = flag => ({
  type: caseTypes.SET_POPULATE_PAYLOAD_SUCCESS,
  flag,
});

export const getCasesFailure = error => ({
  type: caseTypes.GET_CASE_DETAIL_FAILURE,
  error,
});

export const hydrateCases = payload => ({
  type: caseTypes.HYDRATE_CASES,
  payload,
});

// toggle modal shut, getCases with caseFilters payload
export const applyCasesFilters = caseFilters => {
  return async dispatch => {
    await fetchCases(caseFilters)
      .then(res => {
        if (res.success) {
          dispatch(hydrateCasesParams(caseFilters));
          dispatch(getCasesSuccess(res));
        } else throw new Error(res.error.message);
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const applyFiltersSuccess = () => ({
  type: caseTypes.APPLY_CASES_FILTERS_SUCCESS,
});

export const applyFiltersFailure = () => ({
  type: caseTypes.APPLY_CASES_FILTERS_SUCCESS,
});

//showModal
export const toggleModal = (status, anchorEl) => ({
  type: caseTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});

export const goToDetails = rowData => ({
  type: caseTypes.GO_TO_DETAILS,
  rowData,
});

// filters
export const getCaseFilters = payload => {
  return async (dispatch, getState) => {
    try {
      let res = await getCaseFiltersAPI(payload);
      let CountryDetailList;

      if (res.messages && res.messages.defaultCaseYear && res.messages.yearList) {
        // for(let i=0; i<res.messages.defaultCaseYear; i++){
        // let payload = {
        //   year: res.messages.defaultCaseYear,
        // };

        // if(res.messages.yearList[i] && res.messages.yearList[i].year == res.messages.defaultCaseYear){
        let servicePopulate = getState().cases.populatePayload ? false : true;

        // await dispatch(getFiltersServiceType(payload, servicePopulate));
        CountryDetailList = await dispatch(getCountryListOnSelectedYear({ Caseyear: res.messages.defaultCaseYear }, true, servicePopulate));
        await dispatch(
          onChange({
            // ['yearIndex']: i,
            // ['yearId']: res.messages.yearList[i].year,
            ['yearId']: res.messages.defaultCaseYear ? res.messages.defaultCaseYear : undefined,
            ['yearIndex']: res.messages.yearList
              ? res.messages.yearList.findIndex(el => el.year === res.messages.defaultCaseYear)
              : undefined,
            ['countryId']: CountryDetailList.countryId,
            ['countryIndex']: CountryDetailList.countryIndex,
          }),
        );
        // }
        // }
      }
      dispatch(hydratePopulatePayload(false));
      let filters = getState().cases.filters;
      let filtersResponse = res.messages;
      delete filtersResponse['casePhaseList'];
      let res1 = { ...filters, messages: { ...filters.messages, ...filtersResponse, ...CountryDetailList } };

      if (res.success) dispatch(getCaseFiltersSuccess(res1));
      else throw new Error(res.error.message);
    } catch (err) {
      console.error(err);
    }
  };
};

export const getFiltersCasePhases = payload => {
  return async (dispatch, getState) => {
    try {
      let res1 = await fetchFilterCasePhases(payload);
      if (res1.success) {
        let casePhaseList = res1.phaseList ? res1.phaseList : [];
        let filters = getState().cases.filters;
        let res = { ...filters, messages: { ...filters.messages, casePhaseList: casePhaseList } };
        dispatch(getCaseFiltersSuccess(res));
      } else throw new Error(res1.error.message);
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getFiltersEyDetailedStatus = payload => {
  return async (dispatch, getState) => {
    try {
      let res1 = await fetchFilterEyStatus(payload);
      if (res1.success) {
        let eyDetailedStatusList = res1.eyStatusList ? res1.eyStatusList : [];
        let filters = getState().cases.filters;
        let res = { ...filters, messages: { ...filters.messages, eyDetailedStatusList: eyDetailedStatusList } };
        dispatch(getCaseFiltersSuccess(res));
      } else throw new Error(res1.error.message);
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getFiltersPhaseEyDetailedStatus = payload => {
  return async (dispatch, getState) => {
    try {
      let res1 = await fetchFilterPhaseEyStatus(payload);
      if (res1.success && res1.messages) {
        let casePhaseList = res1.messages.casePhaseList ? res1.messages.casePhaseList : [];
        let eyDetailedStatusList = res1.messages.eyDetailedStatusList ? res1.messages.eyDetailedStatusList : [];
        let filters = getState().cases.filters;
        let res = {
          ...filters,
          messages: { ...filters.messages, casePhaseList: casePhaseList, eyDetailedStatusList: eyDetailedStatusList },
        };
        dispatch(getCaseFiltersSuccess(res));
      } else throw new Error(res1.error.message);
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getFiltersServiceType = (payload, serviceRestore) => {
  return async (dispatch, getState) => {
    try {
      let res1 = await fetchFilterServiceType(payload);
      if (res1.success) {
        let serviceTypeList = res1.messages ? res1.messages : [];
        if (serviceRestore && serviceTypeList[0]) {
          await dispatch(
            onChange({
              ['serviceTypeIndex']: undefined,
              [`serviceTypeId`]: undefined,
            }),
          );
        }
        let filters = getState().cases.filters;
        let res = { ...filters, messages: { ...filters.messages, serviceTypeList: serviceTypeList } };
        dispatch(getCaseFiltersSuccess(res));
      } else throw new Error(res1.error.message);
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getCountryListOnSelectedYear = (payload, isFilterUpdate, serviceRestore) => {
  return async (dispatch, getState) => {
    try {
      let res = await fetchFilterCountryByCaseYear(payload);
      if (res.success && res.messages && res.messages.defaultCaseCountry && res.messages.countryList) {
        let payload1 = {
          countryId: res.messages.defaultCaseCountry ? res.messages.defaultCaseCountry : undefined,
          countryIndex: res.messages.countryList
            ? res.messages.countryList.findIndex(el => el.countryId === res.messages.defaultCaseCountry)
            : undefined,
          defaultCaseCountry: res.messages.defaultCaseCountry,
          countryList: res.messages.countryList,
          serviceTypeList: res.messages.serviceTypeList,
        };

        if (serviceRestore) {
          await dispatch(
            onChange({
              ['serviceTypeIndex']: undefined,
              [`serviceTypeId`]: undefined,
            }),
          );
        }
        let filters = getState().cases.filters;

        if (isFilterUpdate) {
          return payload1;
        } else {
          await dispatch(
            onChange({
              ['yearIndex']: filters.messages.yearList
                ? filters.messages.yearList.findIndex(el => el.year === payload.Caseyear)
                : undefined,
              ['yearId']: payload.Caseyear,
              ['countryId']: payload1.countryId,
              ['countryIndex']: payload1.countryIndex,
              ['casePhaseIndex']: undefined,
              [`casePhaseId`]: undefined,
              ['eyStatusId']: undefined,
              [`eyStatusIndex`]: undefined,
            }),
          );
          let res1 = { ...filters, messages: { ...filters.messages, ...res.messages } };
          dispatch(getCaseFiltersSuccess(res1));
        }
      } else throw new Error(res.error.message);
    } catch (error) {
      // console.log(error);
    }
  };
};

export const resetFiltersCasePhases = () => {
  return async (dispatch, getState) => {
    let filters = getState().cases.filters;
    let res = { ...filters, messages: { ...filters.messages, casePhaseList: [], serviceTypeList: [], eyDetailedStatusList: [] } };
    dispatch(getCaseFiltersSuccess(res));
  };
};

export const getCaseFiltersSuccess = payload => ({
  type: caseTypes.GET_FILTERS_SUCCESS,
  payload,
});

export const getImmigrationPathwayList = () => {
  return async dispatch => {
    const res = await getImmigrationPathway();
    if (res.success) dispatch(getImmigrationPathwayListSuccess(res.pathways));
  };
};

export const savePathway = (payload, cb = res => {}) => {
  return async (dispatch, getState) => {
    const response = await saveCasePathway(payload);
    if (response && response.success) {
      cb(true);
    } else cb(false);
  };
};

export const getImmigrationPathwayListSuccess = payload => ({
  type: caseTypes.GET_IMMIGRATION_PATHWAY_SUCCESS,
  payload,
});

export const getCaseMessagesCountsSuccess = data => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_SUCCESS,
  data,
});

export const getCaseMessagesCountsFailure = err => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_FAILURE,
  err,
});

export const resetCaseManagerId = () => ({
  type: caseTypes.RESET_CASE_MANAGER_ID,
});

export const storeCaseDetails = caseDetails => ({
  type: caseTypes.STORE_CASE_DETAILS,
  caseDetails,
});

export const storeCaseManagerId = caseManagerId => ({
  type: caseTypes.STORE_CASE_MANAGER_ID,
  caseManagerId,
});

export const getCaseMessagesCountsPending = () => ({
  type: caseTypes.GET_CASES_MESSAGES_COUNTS_PENDING,
});

export const getCasePhasesSuccess = data => ({
  type: caseTypes.GET_CASE_PHASES_SUCCESS,
  data,
});

export const getCasePhases = caseManagerId => {
  return async dispatch => {
    const response = await fetchCasePhasesService({ caseManagerId });
    if (response && response.success) {
      dispatch(getCasePhasesSuccess(response));
    }
  };
};

export const getCaseConsentSuccess = data => ({
  type: caseTypes.GET_CASE_CONSENTS_SUCCESS,
  data,
});

export const getCasesConsents = caseManagerId => {
  return async dispatch => {
    const response = await fetchCaseConsents({ caseManagerId });
    if (response && response.success) {
      dispatch(getCaseConsentSuccess(response));
    }
  };
};

export const getDocument = documentId => {
  return async dispatch => {
    let { success, ...response } = await openDocumentAPI(documentId);
    if (success) {
      dispatch(getDocumentSucess(response));
      if (response.documentData) {
        let data = response.documentData;
        let fileName = response.fileName;
        let type = mime.lookup(fileName);
        download(atob(data), fileName, type);
      }
    }
  };
};

export const getDocumentSucess = payload => ({
  type: caseTypes.OPEN_DOCUMENTS_SUCCESS,
  payload,
});

export const handleOpenConsent = (caseManagerId, consentVersionId) => async dispatch => {
  const response = await openDocument({ caseManagerId, consentVersionId });
  if (response && response.success) {
    if (response.documentData) {
      let data = response.documentData;
      let fileName = response.fileName;
      let type = mime.lookup(fileName);
      download(atob(data), fileName, type);
    }
  }
};

export const updateCasePhase = data => {
  return async dispatch => {
    const response = await updateCasePhaseService(data);
    // if (response && response.success) {
    //   dispatch(getCasePhases(data.caseManagerId));
    // }
    return response;
  };
};

export const getProductListByOrgYearPending = () => ({
  type: caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_PENDING,
});

export const getProductListByOrgYearSuccess = payload => ({
  type: caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_SUCCESS,
  payload,
});

export const getProductListByOrgYearFailure = error => ({
  type: caseTypes.GET_PRODUCTLIST_BY_ORGYEAR_FAILURE,
  error,
});

export const getProductListByOrgYear = data => {
  return dispatch => {
    dispatch(getProductListByOrgYearPending());
    getProductListByOrgYearService(data)
      .then(res => {
        if (res.success) {
          dispatch(getProductListByOrgYearSuccess({ productsList: res.messages }));
        } else {
          if (res.error) {
            dispatch(getProductListByOrgYearFailure(res.error));
          }
        }
      })
      .catch(err => {
        dispatch(getProductListByOrgYearFailure(err));
      });
  };
};

export const createTaxChatQuestionnairePending = () => ({
  type: caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_PENDING,
});

export const createTaxChatQuestionnaireSuccess = payload => ({
  type: caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_SUCCESS,
  payload,
});

export const createTaxChatQuestionnaireFailure = error => ({
  type: caseTypes.CREATE_TAXCHAT_QUESTIONNAIRE_FAILURE,
  error,
});

export const createTaxChatQuestionnaire = (data, notifText) => {
  return dispatch => {
    dispatch(createTaxChatQuestionnairePending());
    createTaxChatQuestionnaireService(data)
      .then(res => {
        if (res.success) {
          dispatch(showNotificationSuccess(notifText));
          dispatch(createTaxChatQuestionnaireSuccess({ response: res }));
        } else {
          if (res.error) {
            dispatch(createTaxChatQuestionnaireFailure(res.error));
          }
        }
      })
      .catch(err => {
        dispatch(createTaxChatQuestionnaireFailure(err));
      });
  };
};

export const getChaseFrequencySuccess = data => ({
  type: caseTypes.GET_ENGAGEMENT_FREQUENCY_LIST,
  data: data,
});

export const getChaseFrequency = () => async dispatch => {
  try {
    const resp = await fetchChaseFrequencyList();
    if (resp.success) {
      dispatch(getChaseFrequencySuccess(resp.frequencyList));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getAdditionalInfo = caseManagerId => {
  return async (dispatch, getState) => {
    try {
      /* two pieces to the details page: Details information + Details Header */
      const response = await fetchAdditionalInfo(caseManagerId);
      if (response && response.success && response.messages) {
        dispatch(getAdditionalInfoSuccess(response.messages));
        dispatch(getExtensionDetailsContactsSuccess(response));
      }
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getAdditionalInfoSuccess = caseDetails => ({
  type: caseTypes.GET_ADDITIONAL_INFO_SUCCESS,
  caseDetails,
});

export const updateRelatedReturnStore = relatedReturn => ({
  type: caseTypes.UPDATE_RELATED_RETURN_STORE,
  relatedReturn,
});

export const getCaseStatusSuccess = data => ({
  type: caseTypes.GET_CASE_STATUS_SUCCESS,
  data: data,
});

export const getCaseStatusList = () => async dispatch => {
  try {
    const resp = await fetchGetCaseStatus();
    if (resp.success && resp.messages) {
      dispatch(getCaseStatusSuccess(resp.messages));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const showNotificationSuccess = message => ({
  type: caseTypes.SHOW_CREATE_QUEST_NOTIFICATION_SUCCESS,
  message,
});

export const hideNotificationSuccess = () => ({
  type: caseTypes.HIDE_CREATE_QUEST_NOTIFICATION_SUCCESS,
});

//Experian APIs
export const getExperianResults = caseManagerId => async dispatch => {
  try {
    const resp = await getExperianResultsService(caseManagerId);
    if (resp.success) {
      dispatch(getExperianResultsSuccess(resp));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getExperianResultsSuccess = data => ({
  type: caseTypes.GET_EXPERIAN_RESULTS_SUCCESS,
  data: data,
});

export const getExperianResultsFailure = () => ({
  type: caseTypes.GET_EXPERIAN_RESULTS_FAILURE,
  data: {},
});

export const getExperianBgCheckResults = caseManagerId => async dispatch => {
  try {
    let resp = await getExperianBgCheckResultsService(caseManagerId);
    if (resp.success) {
      dispatch(getExperianBgCheckResultsSuccess(resp));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getExperianBgCheckResultsSuccess = data => ({
  type: caseTypes.GET_EXPERIAN_BGCHECK_RESULTS_SUCCESS,
  data: data,
});

export const getExperianBgCheckResultsFailure = () => ({
  type: caseTypes.GET_EXPERIAN_BGCHECK_RESULTS_FAILURE,
  data: {},
});

export const getExperianPDF = caseManagerId => async dispatch => {
  try {
    const resp = await getExperianPDFService(caseManagerId);
    if (resp.success) {
      dispatch(getExperianPDFSuccess(resp));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getExperianPDFSuccess = data => ({
  type: caseTypes.GET_EXPERIAN_PDF_SUCCESS,
  data: data,
});

export const getExperianPDFFailure = () => ({
  type: caseTypes.GET_EXPERIAN_PDF_FAILURE,
  data: {},
});

export const getExperianTestExportToPDF = testImageId => async dispatch => {
  try {
    const res = await getExperianTestExportToPDFService(testImageId);
    if (res.success) {
      dispatch(getExperianTestExportToPDFSuccess(res));
      saveAPIFile(res.documentData, res.fileName + '.' + res.fileType);
      //   download(atob(res.documentData), res.fileName, res.fileType);
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getExperianTestExportToPDFSuccess = data => ({
  type: caseTypes.GET_EXPERIAN_TEST_EXPORT_TO_PDF_SUCCESS,
  payload: data,
});

export const getPersonProfilePdfByRESCode = (resID, qrCode) => async dispatch => {
  try {
    const res = await personProfilePdfByResourceCodeSvc(resID);
    if (res.success) {
      saveAPIFile(res.profilePdf, 'profile_' + qrCode + '.pdf');
    }
  } catch (error) {
    // console.log(error);
  }
};

export const updateBackgroundCheckDetail = payload => async dispatch => {
  try {
    const res = await updateBackgroundCheckDetailSvc({ ...payload, caseManagerId: undefined });
    if (res.sucess) {
      dispatch(getExperianBgCheckResults(payload.caseManagerId));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const downloadAnswerKey = caseManagerId => async dispatch => {
  const response = await downloadAnswerKeyXML(caseManagerId);
  if (response && response.success) {
    if (response.attachmentData) {
      let data = response.attachmentData;
      let fileName = response.fileName;
      let type = mime.lookup(fileName);
      download(atob(data), fileName, type);
    }
  }
};

export const downloadSurePrepBinder = caseManagerId => async dispatch => {
  const response = await downloadSurePrepBinderService(caseManagerId);
  if (response && response.success) {
    if (response.filebytes) {
      let data = response.filebytes;
      let fileName = response.fileName;
      let type = mime.lookup(fileName);
      download(atob(data), fileName, type);
    }
    dispatch(showNotification(response.message, { variant: 'success' }));
  }
  if (response.success === false) {
    dispatch(showNotification(response.message, { variant: 'error' }));
  }
};

export const deliverReturn = caseManagerId => async dispatch => {
  const response = await deliverReturnStatus(caseManagerId);
  if (response && response.success) {
    return response;
  }
  return response;
};

export const deliverReturnPriceInfo = caseManagerId => async dispatch => {
  const response = await deliverReturnPriceInfoService(caseManagerId);
  if (response && response.success) {
    return response;
  }
  return response;
};

export const syncSurePrepBinder = payload => async dispatch => {
  const response = await syncSurePrepBinderStatus(payload);
  if (response && response.success) {
    return response;
  }
  return response;
};

export const deleteCaseAdmin = payload => {
  return async dispatch => {
    const response = await deleteCaseService(payload);
    return response;
  };
};

export const resetBinderCreate = payload => {
  return async dispatch => {
    const response = await resetBinderCreateStatus(payload);
    return response;
  };
};


export const resetDocumentsUpload = payload => {
  return async dispatch => {
    const response = await resetDocumentsUploadStatus(payload);
    return response;
  };
};


export const getEyStatus = options => async dispatch => {
  try {
    const resp = await fetchEYCaseStatus(options);
    if (resp.success) {
      let data = resp.rows;
      data['isInitiateEFileEnable'] = resp.isInitiateEFileEnable;
      dispatch(getEyStatusSuccess(resp.rows, resp.totalAPIRows));
      dispatch(getEyStatusSuccessApiTable(resp.apiStatus));
      dispatch(getEyStatusCountry(resp.caseCountry));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getEyStatusSuccess = (data, totalAPIRows) => ({
  type: caseTypes.GET_EY_STATUS_SUCCESS,
  data: data,
  totalAPIRows: totalAPIRows,
});

export const getEyStatusApi = caseManagerId => async dispatch => {
  try {
    const resp = await fetchEYCaseStatus(caseManagerId);
    if (resp.success) {
      dispatch(getEyStatusSuccessApiTable(resp.apiStatus));
      dispatch(getEyStatusCountry(resp.caseCountry));
    }
  } catch (error) {
    // console.log(error);
  }
};

export const getEyStatusSuccessApiTable = data => ({
  type: caseTypes.GET_EY_STATUS_SUCCESS_API_TABLE,
  data: data,
});

export const getEyStatusCountry = data => ({
  type: caseTypes.GET_EY_STATUS_COUNTRY,
  data: data,
});

export const initiateEFile = caseManagerId => async dispatch => {
  const response = await initiateEFileStatus(caseManagerId);
  if (response && response.success) {
    return response;
  }
  return response;
};

export const eyFileButton = () => ({
  type: caseTypes.EY_FILE_BUTTON,
  data: false,
});

export const experianmessageChat = data => ({
  type: caseTypes.EXPERIAN_CHAT_MESSAGE,
  data,
});

export const setFavoriteCase = (caseManagerId, isChecked, rowIndex) => {
  return async dispatch => {
    try {
      let { response } = await setFavoriteMarkService({
        caseManagerId: caseManagerId,
        IsFavorite: isChecked,
      });
      dispatch(setFavoriteCaseSuccess(rowIndex, isChecked));
      if (response && !response.success) dispatch(setFavoriteCaseSuccess(rowIndex, !isChecked));
    } catch (error) {
      dispatch(setFavoriteCaseSuccess(rowIndex, !isChecked));
    }
  };
};

export const setFavoriteCaseSuccess = (payload, isChecked) => ({
  type: caseTypes.FAVORITE_CHECKBOX,
  payload,
  isChecked,
});

export const getLogsList = options => {
  return async dispatch => {
    await getTaxcaddyList(options)
      .then(res => {
        if (res.success) dispatch(getLogsSuccess(res));
        else throw new Error(res.error.message);
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getLogsSuccess = logs => {
  return dispatch => {
    dispatch({
      type: caseTypes.GET_LOGS_LIST_SUCCESS,
      logs,
    });
  };
};


export const getMissingInformationDetails = caseManagerId => {
  return async dispatch => {
    try {  
    const res = await fecthMissingInformationDetails( caseManagerId );
      if (res && res.success) {
        dispatch(getMissingInformationDetailsSuccess(res));
      }else {
        dispatch(getMissingInformationDetailsFailure());
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getMissingInformationDetailsSuccess = data => ({
  type: caseTypes.GET_MISSING_INFO,
  data: data,
});

export const getMissingInformationDetailsFailure = data => ({
  type: caseTypes.GET_MISSING_INFO_FAILURE,
  data: data,
});

export const addMissingInfoDialogData = data => {
  return async dispatch => {
    try {  
    const res = await addMissingInfoDialog( data );
    const { message ,Message } = res;
      if (res && res.success) {
        dispatch(showNotification(res.message, { variant: 'success' }));
      }else {
        dispatch(showNotification(message ? message : Message, { variant: 'error' }));
      }
    } catch (err) {
      console.error(err);
    }
  };
};


export default {
  getCaseMessagesCountsPending,
  getCaseIdsPending,
  getCaseIdsSuccess,
  getCaseIdsFailure,
  getCaseDetailPending,
  getCaseDetailSuccess,
  getCaseDetailFailure,
  getCasesPending,
  getCasesSuccess,
  getCasesFailure,
  getCaseFilters,
  storeCaseManagerId,
  toggleModal,
  getImmigrationPathwayList,
  savePathway,
  getChaseFrequency,
  getFiltersCasePhases,
  resetFiltersCasePhases,
  hydratePopulatePayload,
  getExperianResults,
  getExperianPDF,
  getExperianTestExportToPDF,
  getPersonProfilePdfByRESCode,
  updateBackgroundCheckDetail,
  getEyStatus,
  getDocument,
  initiateEFile,
  getEyStatusApi,
  downloadSurePrepBinder,
  getPrimaryCaseContactslist,
  getSecondaryCaseContactslist,
  getDelegateCaseContactslist,
  experianmessageChat,
  setFavoriteCase,
  upadteDelegateProfile,
  getLogsList,
  updateExtension,
  getTeritaryCaseContactslist,
  getCOEMemberCaseContactslist,
  deleteCaseAdmin,
  resetBinderCreate,
  resetDocumentsUpload,
  getMissingInformationDetails,
  getMissingInformationDetailsFailure,
  addMissingInfoDialogData
};



// WEBPACK FOOTER //
// ./src/ui/features/Cases/state/casesActions.js